import { render, staticRenderFns } from "./vinden.vue?vue&type=template&id=266f7054&"
import script from "./vinden.vue?vue&type=script&lang=js&"
export * from "./vinden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GeneralBreadcrumbs: require('/home/nvpa/nvpa-corporate/nuxt/components/general/Breadcrumbs.vue').default,TherapistSearch: require('/home/nvpa/nvpa-corporate/nuxt/components/therapist/Search.vue').default,TherapistCard: require('/home/nvpa/nvpa-corporate/nuxt/components/therapist/Card.vue').default,GeneralPagination: require('/home/nvpa/nvpa-corporate/nuxt/components/general/pagination.vue').default,GeneralTour: require('/home/nvpa/nvpa-corporate/nuxt/components/general/Tour.vue').default})
